import React, { memo } from 'react'
import { Button } from 'src/components/shared/Button'
import { useSendTestWebhookGate } from './useSendTestWebhookGate'

interface Props {
  formId: string
}

/**
 * The modal footer's submit. Rendered by `CommonModal` outside the `<Form>` element but inside
 * the Formik provider (context crosses the portal), so it can read the gate and submit by
 * `form` id.
 */
const SendTestWebhookSubmitButtonComponent = ({ formId }: Props) => {
  const { isBlocked, isSending } = useSendTestWebhookGate()

  return (
    <Button
      size="small"
      color="dark"
      type="submit"
      form={formId}
      loading={isSending}
      disabled={isBlocked || isSending}
      data-testid="send-test-webhook-submit-button"
    >
      Send test event
    </Button>
  )
}

export const SendTestWebhookSubmitButton = memo(SendTestWebhookSubmitButtonComponent)
